var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    attrs: {
      "height": _vm.height
    }
  }, [_c('aspect-ratio-box', {
    staticClass: "relative",
    attrs: {
      "ratio": 4 / 2
    }
  }, [_c('skeleton', {
    attrs: {
      "height": "100%",
      "width": "100%"
    }
  })], 1), _vm._v(" "), _c('card-title', {
    attrs: {
      "large": ""
    }
  }, [_c('skeleton', {
    staticClass: "mb-8",
    attrs: {
      "height": "25",
      "min-width": 80,
      "rounded": ""
    }
  })], 1), _vm._v(" "), _c('card-subtitle', {
    attrs: {
      "x-small": ""
    }
  }, [_c('skeleton', {
    staticClass: "mb-10",
    attrs: {
      "width": "160",
      "height": "12",
      "rounded": ""
    }
  })], 1), _vm._v(" "), _c('card-text', {
    staticClass: "text-truncate"
  }, [_c('paragraph-skeleton', {
    attrs: {
      "lines": 3,
      "small": ""
    }
  })], 1), _vm._v(" "), _c('card-subtitle', [_c('chip-skeleton', {
    attrs: {
      "width": "120",
      "small": ""
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }